export default __webpack_public_path__ + "static/media/classy.da469d6b.jpg";